<script setup lang="ts">
import type { LegalDocumentId } from '@falasta/contracts';
import { onMounted } from 'vue';

import { startAnalytics } from '../analytics/cookie-consent';
import CookieBanner from '../components/CookieBanner.vue';
import LegalDocumentSection from '../components/LegalDocumentSection.vue';
import SiteFooter from '../components/SiteFooter.vue';
import SiteHeader from '../components/SiteHeader.vue';
import { LEGAL_EFFECTIVE_DATE, legalDocument } from '../content/legal-content';
import '../styles/components.css';

/**
 * Guscio delle pagine legali: la stessa barra e lo stesso piede della copertina
 * attorno a un documento.
 *
 * Il documento arriva come proprietà dal punto d'ingresso della pagina (uno per
 * file HTML) invece di essere dedotto dall'indirizzo: così non esiste un
 * percorso in cui la pagina `/privacy` mostri i termini perché una regola di
 * routing è stata scritta male.
 */
const props = defineProps<{ document: LegalDocumentId }>();

onMounted(() => {
  startAnalytics();
});
</script>

<template>
  <SiteHeader />
  <main class="page">
    <LegalDocumentSection
      :document="legalDocument(props.document)"
      :version="LEGAL_EFFECTIVE_DATE"
    />
  </main>
  <SiteFooter />
  <CookieBanner />
</template>
